<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter6">
<h1 class="left"><a id="page_40"></a><a href="#/005toc#ch6"><span class="yellow">POMEGRANATE-MOLASSES CHICKEN DRUMMETTES</span></a></h1>
<p class="noindent">The sweet-tart flavor of pomegranate juice and the caramel flavor of molasses make a complementary marinade for these grilled drummettes. They make a good starter for a barbecue when the grill is fired up. Drummettes are the bony part of the wing and can be purchased in packages at most meat markets.</p>
<p class="hang-space1">2 to 2 <sup class="frac">1</sup>/<sub class="frac">2</sub> pounds chicken drummettes (about 20)</p>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">2</sub> cup unsulphured molasses</p>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">2</sub> cup pomegranate juice</p>
<p class="noindent-space1">Place the drummettes in a 9-by-13-inch glass baking dish. In a small bowl, mix together the molasses and juice. Pour over the drummettes and marinate several hours in the refrigerator. Bring to room temperature before grilling.</p>
<p class="noindent-space1">Prepare a grill for cooking over medium indirect heat. Remove the drummettes from the marinade and boil the marinade in a small pan for 1 minute. Place the drummettes on a lightly sprayed or oiled grate and grill until lightly browned and cooked through, about 25 minutes, turning several times and brushing with the boiled marinade.</p>
<p class="noindent-space1">Makes 20 pieces</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 014-chapter6.vue?85a0db92